/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CarServiceHistoryData } from '../models/CarServiceHistoryData';
import type { FlightHistoryData } from '../models/FlightHistoryData';
import type { LodgingHistoryData } from '../models/LodgingHistoryData';
import type { OtherHistoryData } from '../models/OtherHistoryData';
import type { RentalCarHistoryData } from '../models/RentalCarHistoryData';
import type { TrainHistoryData } from '../models/TrainHistoryData';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class HistoryDataService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param patientId
     * @returns CarServiceHistoryData
     * @throws ApiError
     */
    public historyDataGetCarServiceHistoryData(
        patientId: number,
    ): Observable<Array<CarServiceHistoryData>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/history/carService/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns LodgingHistoryData
     * @throws ApiError
     */
    public historyDataGetLodgingHistoryData(
        patientId: number,
    ): Observable<Array<LodgingHistoryData>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/history/lodging/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns RentalCarHistoryData
     * @throws ApiError
     */
    public historyDataGetRentalCarHistoryData(
        patientId: number,
    ): Observable<Array<RentalCarHistoryData>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/history/rentalCar/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns FlightHistoryData
     * @throws ApiError
     */
    public historyDataGetFlightHistoryData(
        patientId: number,
    ): Observable<Array<FlightHistoryData>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/history/flight/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns TrainHistoryData
     * @throws ApiError
     */
    public historyDataGetTrainHistoryData(
        patientId: number,
    ): Observable<Array<TrainHistoryData>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/history/train/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns OtherHistoryData
     * @throws ApiError
     */
    public historyDataGetOtherHistoryData(
        patientId: number,
    ): Observable<Array<OtherHistoryData>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/history/other/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
}
